import { useGetGoal } from '@akin-home/goals/frontend';
import React, { FC } from 'react';
import {
  Platform,
  StyleProp,
  useWindowDimensions,
  ViewStyle,
} from 'react-native';
import styled from 'styled-components/native';
import GoalCard from '../../goals/components/GoalCard';
import { getGoalCompletionProgress } from '../../goals/functions';
import { useIncrementGoal } from '../../goals/hooks/useIncrementGoal';
import { useRootStackNavigation } from '../../navigation/hooks';
import { palette } from '../../theme';
import { useCurrentUserID } from '../../users';

interface Props {
  goal_id: string;
  date: Date;

  style?: StyleProp<ViewStyle>;
}

const CalendarItemDetailsGoalSection: FC<Props> = (props) => {
  const { goal_id, date } = props;

  const user_id = useCurrentUserID();

  const { goal } = useGetGoal(goal_id);
  const { navigate } = useRootStackNavigation();

  const key = { user_id, date };

  const increment = useIncrementGoal(key);

  const handlePress = () => {
    goal && increment(goal);
  };

  const handleLongPress = () => {
    goal && increment(goal, -1);
  };

  const onEditPress = () => goal && navigate('EditGoal', { id: goal.id });

  const { width } = useWindowDimensions();
  const isSmallCardRequired = width < 500;

  return goal ? (
    <Card
      style={props.style}
      goal={goal}
      progress={getGoalCompletionProgress(goal, key)}
      onPress={handlePress}
      onLongPress={handleLongPress}
      onPressEdit={onEditPress}
      smallVariant={isSmallCardRequired}
    />
  ) : null;
};

const Card = styled(GoalCard)({
  maxWidth: 500,
  flex: 1,
  ...Platform.select({
    web: {
      borderColor: palette.Secondary_blue,
      borderWidth: 2,
    },
  }),
});

export default CalendarItemDetailsGoalSection;
